export default "__VITE_ASSET__CKY74o3O__"